import { Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';
import { OptionalNote } from './OptionalNote';

export const StillDecidingContent = (props: {
  control: Control<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
}) => {
  return (
    <div className='flex flex-col gap-4 items-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <OptionalNote control={props.control} placeholder='Enter details' />}
    </div>
  );
};
